import React, { useEffect, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Button, Modal, Upload } from "antd";
import { v4 as uuid } from "uuid";
const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
const UploadImages = ({
  onDataReceived,
  setImagesList,
  isModalOpen,
  fileList,
  setFileList,
}) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const handleCancel = () => setPreviewOpen(false);
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
    );
  };
  const handleChange = ({ fileList: newFileList }) => {
    var listAdd = {
      uid: uuid,
      name: "",
      status: "",
      url: "",
    };
    setFileList([...newFileList], listAdd);
    onDataReceived(fileList);
  };
  useEffect(() => {
    if (fileList.length > 0) {
      var uris = "";
      fileList.forEach((element) => {
        uris += element?.response?.files[0]?.url;
      });
      setImagesList(uris);
    }
  }, [fileList]);
  const uploadButton = <Button>Upload</Button>;
  return (
    <>
      <Upload
        action="https://deliziora-api.azurewebsites.net/menu/add-image"
        listType="picture-card"
        fileList={fileList}
        onPreview={handlePreview}
        onChange={handleChange}
        maxCount={1}
      >
        {uploadButton}
      </Upload>
      <Modal
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
      >
        <img
          style={{
            width: "10%",
          }}
          src={previewImage}
        />
      </Modal>
    </>
  );
};
export default UploadImages;
